import { render, staticRenderFns } from "./AdiMobilitaIndiceBarthelComponent.vue?vue&type=template&id=a3e12c32"
import script from "./AdiMobilitaIndiceBarthelComponent.vue?vue&type=script&lang=js"
export * from "./AdiMobilitaIndiceBarthelComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports